import { render } from "./AboutView.vue?vue&type=template&id=48dedea6"
const script = {}

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__